import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from '@app/ui/pages/landing-page/landing-page';
import { LkPage } from '@app/ui/pages/lk-page';
import PageNotFound from '@app/ui/pages/page-not-found/page-not-found.component';

export const RootPageComponent: React.FC = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/lk' element={<LkPage />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
